import {spacing} from '@logistics-frontend/blocks/theme/theme'
import clsx from 'clsx'
import React, {useMemo} from 'react'

import {classes as baseClasses} from './Skeleton.classes'
import type {Props} from './Skeleton.types'

export function Skeleton({className, classes, width, height}: Props): React.ReactElement<Props> {
  const style: React.CSSProperties = useMemo(
    () => ({
      inlineSize: width ? spacing(width) : undefined,
      blockSize: height ? spacing(height) : undefined,
    }),
    [width, height],
  )
  return (
    <div className={clsx(baseClasses.root, classes?.root, className)} style={style}>
      <div className={clsx(baseClasses.skeleton, classes?.skeleton)} />
    </div>
  )
}
